import { connectInfiniteHits } from 'instantsearch.js/es/connectors'
import hitPortrait from './hitPortrait'
import hitArticle from './hitArticle'
import hitInfography from './hitInfography'
import hitCommitment from './hitCommitment'
import hitPodcastVideo from './hitPodcastVideo'
import hitActu from './hitActu'
import hitPressRelease from './hitPressRelease'
import hitMedia from './hitMedia'

let isInit = true

const renderInfiniteHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams, showMore, isLastPage } = renderOptions

  if (isFirstRender) {
    const nextButtonWrapper = document.createElement('div')
    const nextButton = document.createElement('button')

    nextButtonWrapper.className = 'flex flex-col items-center paginate-wrapper'
    nextButton.className = 'button button--icon button--grass-green next-button'
    nextButton.innerHTML = `<svg width="16" height="16" class="icon--white mr-2"><use href="#icon-plus" xlink:href="#icon-plus" /></svg>${config.trads[`${widgetParams.type === 'portrait' ? 'portrait' : 'single-committed'}.more`]}`
    nextButton.addEventListener('click', () => {
      showMore()

      if (typeof _paq !== 'undefined') {
        if (widgetParams.type === 'press-release') {
          _paq.push(['trackEvent', 'communique-de-presse', 'newsroom', 'afficher plus de contenus'])
        } else if (widgetParams.type === 'actuality') {
          _paq.push(['trackEvent', 'actualite', 'newsroom', 'afficher plus de contenus'])
        } else if (widgetParams.type === 'medias') {
          _paq.push(['trackEvent', 'mediatheque', 'newsroom', 'afficher plus de contenus'])
        }
      }
    })

    if (widgetParams.hasPaginate) {
      const paginate = document.createElement('p')
      paginate.className = 'paginate text-grass-green title title--4'
      paginate.innerHTML = `<span js-nb-showed>9</span> ${config.trads.of} <span js-total>25</span>`
      nextButtonWrapper.appendChild(paginate)
    }

    widgetParams.container.appendChild(nextButtonWrapper)
    nextButtonWrapper.appendChild(nextButton)

    return
  }

  widgetParams.container.querySelector('.next-button').disabled = isLastPage

  if (widgetParams.hasPaginate && widgetParams.container.querySelector('[js-nb-showed]')) {
    widgetParams.container.querySelector('[js-nb-showed]').innerHTML = renderOptions.hits.length
    widgetParams.container.querySelector('[js-total]').innerHTML = renderOptions.results.nbHits
  }

  if (widgetParams.container.querySelector('.empty')) {
    widgetParams.container.querySelector('.empty').remove()
    widgetParams.container.querySelector('ul').nextElementSibling.classList.remove('hidden')
    widgetParams.container.querySelector('ul').nextElementSibling.classList.add('flex')
  }

  if (hits.length !== 0) {
    widgetParams.container.querySelector('ul').innerHTML = ''

    hits.forEach((hit) => {
      // create li element, add classes
      const li = document.createElement('li')

      if (widgetParams.type === 'portrait') {
        li.className = 'col-12 md-col-6 lg-col-4 mb-6 md:mb-14 flex'
        li.innerHTML = hitPortrait(hit, isInit)
      } else if (widgetParams.type === 'single-committed') {
        li.className = 'col-12 md-col-6 lg-col-4 mb-8 md:mb-16 flex'
        if (hit.thematic === 'article') {
          li.innerHTML = hitArticle(hit, isInit)
        } else if (hit.thematic === 'commitment') {
          li.innerHTML = hitCommitment(hit, isInit)
        } else if (hit.thematic === 'infography') {
          li.innerHTML = hitInfography(hit, isInit)
        } else {
          li.innerHTML = hitPodcastVideo(hit, isInit)
        }
      } else if (widgetParams.type === 'actuality') {
        li.className = 'col-12 md-col-6 lg-col-4 mb-10 flex'
        li.innerHTML = hitActu(hit, isInit)
      } else if (widgetParams.type === 'press-release') {
        li.className = 'col-12 md-col-6 lg-col-4 mb-10 flex'
        li.innerHTML = hitPressRelease(hit, isInit)
      } else if (widgetParams.type === 'medias') {
        li.className = 'col-12 md-col-6 lg-col-4 mb-10 flex'
        li.innerHTML = hitMedia(hit, isInit, widgetParams.contactUrl)
      }

      widgetParams.container.querySelector('ul').appendChild(li)
    })
  } else {
    widgetParams.container.querySelector('ul').innerHTML = ''
    widgetParams.container.querySelector('ul').nextElementSibling.classList.add('hidden')
    widgetParams.container.querySelector('ul').nextElementSibling.classList.remove('flex')

    const empty = document.createElement('p')
    empty.classList.add('empty')
    empty.innerHTML = config.trads[widgetParams.type === 'portrait' ? 'portrait' : 'single-committed' + '.empty']
    widgetParams.container.append(empty)
  }

  isInit = false
}

const customHits = connectInfiniteHits(renderInfiniteHits)

export default customHits
